import { Link, Outlet } from "react-router-dom";
import { AdministrationTabs } from "./AdministrationTabs";

export const Administration = () => {
  return (
    <>
      <div
        className="d-flex align-items-center px-5 py-2 border-bottom"
        aria-label="breadcrumb"
      >
        <div className="flex-fill d-flex align-items-center">
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item breadcrumb-item-first">
                <Link to="/home">
                  <span className="material-symbols-outlined fs-14">home</span>
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {"Administration"}
              </li>
            </ol>
            <h1 className="h3 m-0">{"Administration"}</h1>
          </div>
        </div>
      </div>
      <AdministrationTabs />
      <Outlet />
    </>
  );
};
